import axios from 'axios';

const siteConfig = {};
Object.assign(siteConfig, window.merlinConfig);

const noResultsContainer = document.querySelector("#AttractionsResult");
const form = document.querySelector("#google-maps-form");
const formInput = document.querySelector("#google-maps-input");

const passPickupSection = document.querySelector("[data-pass-pickup-section]");

formInput.disabled = false;

const buyAnnualPassObj = {
    passType: "",
    lat: null,
    lng: null
};

const checkmark =
    `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" aria-hidden="true" focusable="false">
  <path d="M12.9 23.7l-7.6-7.6c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0l6.2 6.2L25.3 8.6c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4L12.9 23.7z"/>
</svg>`;

var selectFirstOnEnter = function (input) {

    // store the original event binding function
    var eventListener = input.addEventListener ? input.addEventListener : input.attachEvent;

    // Simulate a 'down arrow' keypress on hitting 'return' when no pac suggestion is selected, and then trigger the original listener.
    function addEventListenerWrapper(type, listener) {
        if (type == "keydown") {
            var origListener = listener;
            listener = function (event) {
                var suggestionSelected = $(".pac-item-selected").length > 0;
                if (event.which == 13 && !suggestionSelected) {
                    var simulatedDownarrow = $.Event("keydown", { keyCode: 40, which: 40 });
                    origListener.apply(input, [simulatedDownarrow]);
                }
                origListener.apply(input, [event]);
            };
        }
        // add the modified listener
        eventListener.apply(input, [type, listener]);
    }

    if (input.addEventListener) {
        input.addEventListener = addEventListenerWrapper;
    } else if (input.attachEvent) {
        input.attachEvent = addEventListenerWrapper;
    }
};


const autocomplete = new google.maps.places.Autocomplete(formInput);
autocomplete.setComponentRestrictions(MAPsettings.restrictions);
autocomplete.setTypes(['(regions)']);
autocomplete.setFields(["geometry", "name"]);// Specify only the data fields that are needed.
autocomplete.addListener("place_changed", () => {

    const place = autocomplete.getPlace();

    if (!place.geometry) {
        // User entered the name of a Place that was not suggested and
        // pressed the Enter key, or the Place Details request failed.
        console.log("No details available for input: '" + place.name + "'");
        return;
    }

    // If the place has a geometry, then present it on a map.
    if (place.geometry.location) {
        buyAnnualPassObj.lat = place.geometry.location.lat().toString();
        buyAnnualPassObj.lng = place.geometry.location.lng().toString();
        loadData();
    }

});


//restrictions are set in "AttractionsListMap.cshtml"
selectFirstOnEnter(formInput);

function attractionsForListViewCallback(results) {
    const container = document.getElementById("AttractionsListContainer");
    container.innerHTML = "";

    let list = results.data.map((location, i) => {
        let distance = "";
        let image = "";

        if (location.distanceString && location.distanceString !== "") {
            distance = `<p>${location.distanceString}</p>`;
        }

        if (location.image && location.image !== "") {
            image = `<div class="attraction-link-image"><img src="${location.image}" alt=""></div>`;
        }

        let listItem = `<li>
                <div class="list-item-content-wrapper">
                    ${image}
                    <div class="attraction-link-content stack">
                        <h2 class="header--xsmall">${location.title}</h2>
                        ${distance}
                    </div>
                    <a href="${location.links[0].link.url}" target="${location.links[0].link.target}" class="button button--secondary attraction-link-label">${location.links[0].link.label}</a>
                </div>
            </li>`;

        return listItem;
    });

    let listHtml = `<ul class="attractions-list">${list.join("")}</ul>`;

    container.innerHTML = listHtml;
};

function loadData() {
    let urlParams = `?passtype=${buyAnnualPassObj.passType}`;

    if (buyAnnualPassObj.lat !== null && buyAnnualPassObj.lng !== null) {
        urlParams += `&latitude=${buyAnnualPassObj.lat}&longitude=${buyAnnualPassObj.lng}`;
    }

    axios.get(`${siteConfig.urlPrefix}/umbraco/api/mapfiltering/GetAttractionProducts${urlParams}`)
        .then(response => {
            attractionsForListViewCallback(response);
        })
        .catch(error => {
            console.log(error);
        })
        .finally(() => {
        });
}

function setButtonDefaultText() {
    const buttons = document.querySelectorAll("button[data-pass-type]");
    buttons.forEach(function(but) {
        but.classList.remove("selected");
        if (but.dataset.defaultText === undefined) {
            const defaultText = but.textContent;
            but.dataset.defaultText = defaultText;
        }

        but.textContent = but.dataset.defaultText;
    });
}

function scrollToPassPickupSection() {
    window.scrollTo(0, passPickupSection.offsetTop - 160);
}

function selectPassType(e) {

    if (e.target.matches('button[data-pass-type]')) {

        setButtonDefaultText();

        e.target.innerHTML = `${checkmark}${e.target.dataset.textSelected}`;
        e.target.classList.add("selected");

        buyAnnualPassObj.passType = e.target.dataset.passType;
        passPickupSection.hidden = false;
        
        loadData();
        scrollToPassPickupSection();

        history.replaceState({}, "", window.location.pathname + "?passtype=" + e.target.dataset.passType);
    }
}

document.addEventListener("click", selectPassType);

window.addEventListener("DOMContentLoaded", function(e) {
    const url = window.location.href;
    if (url.includes("?")) {

        const passType = url.split("?")[1].split("=")[1];
        buyAnnualPassObj.passType = passType;

        const but = document.querySelector(`button[data-pass-type="${passType}"]`);
        if (but) {
            but.innerHTML = `${checkmark}${but.dataset.textSelected}`;
            but.classList.add("selected");
            passPickupSection.hidden = false;
            loadData();
            scrollToPassPickupSection();
        }
    } else {
        console.log("No Parameters in URL");
    }
});